import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-586e74f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "server" }
const _hoisted_2 = {
  key: 0,
  class: "failing"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "⚠️Warning⚠️", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The request to get this API's status failed on the last request. Data may not be accurate. ", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "server-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Test = _resolveComponent("Test")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.success)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("h2", null, "Stack " + _toDisplayString(_ctx.id + 1), 1),
    _createElementVNode("p", null, "Last updated: " + _toDisplayString(_ctx.lastUpdated ?? "Never."), 1),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.tests as TestCase[]), (test, index) => {
        return (_openBlock(), _createBlock(_component_Test, {
          key: index,
          name: test.name,
          status: test.status_success,
          description: _ctx.getDesc(test)
        }, null, 8, ["name", "status", "description"]))
      }), 128))
    ])
  ]))
}